const patientsSx = theme => ({
	searchContainer: {
		marginBottom: 64,
	},
	searchButtons: {
		margin: 8,
	},
});

export default patientsSx;
